import httpRequest from '@/services/httpRequest.js'
export default ({
  namespaced: true,
  state: {
    isLoading: false,
    optionsLoading: false,

    // JOURNAL LIST PAGINATION
    journalPagination: {
      page: 1,
      rows: 10,
      hasMore: true,
    },

    // JOURNAL DAILY PAGINATION
    journalDailyPagination: {
      page: 1,
      rows: 10,
      hasMore: true,
    },

    journal: {},
    journalList: [],
    journalDaily: {},
    journalDailyList: [],

    subjectScheduleList: [],
    journalCalendar: {},

    optionsPagination: {
      page: 1,
      rows: 10,
      hasMore: true,
    },

    classrooms: [],
    subjects: [],
    options: [],
  },
  mutations: {
    SET_IS_LOADING(state, status) {
      state.isLoading = status
    },

    SET_JOURNAL_PAGE(state, page) {
      state.journalPagination.page = page;
    },

    SET_JOURNAL_HAS_MORE(state, status) {
      state.journalPagination.hasMore = status;
    },

    SET_JOURNAL_DAILY_PAGE(state, page) {
      state.journalDailyPagination.page = page;
    },

    SET_JOURNAL_DAILY_HAS_MORE(state, status) {
      state.journalDailyPagination.hasMore = status;
    },

    RESET_JOURNAL_PAGINATION(state) {
      state.journalPagination.page = 1;
      state.journalPagination.hasMore = true;
      state.journalList = [];
    },

    RESET_JOURNAL_DAILY_PAGINATION(state) {
      state.journalDailyPagination.page = 1;
      state.journalDailyPagination.hasMore = true;
      state.journalDailyList = [];
    },

    SET_JOURNAL_CALENDAR(state, data) {
      state.journalCalendar = data;
    },

    SET_JOURNAL_CALENDAR_MONTH(
      state,
      { month, data },
    ) {
      if (!state.journalCalendar) {
        state.journalCalendar = {};
      }

      state.journalCalendar[month] = {
        ...(state.journalCalendar[month] || {}),
        ...data,
      };
    },

    CLEAR_JOURNAL_CALENDAR(state) {
      state.journalCalendar = {};
    },

    SET_JOURNAL(state, data) {
      state.journal = data;
    },
    SET_JOURNAL_LIST(state, data) {
      state.journalList = data;
    },
    APPEND_JOURNAL_LIST(state, newData) {
      state.journalList = [
        ...state.journalList,
        ...newData,
      ]
    },
    SET_JOURNAL_DAILY(state, data) {
      state.journalDaily = data;
    },
    SET_JOURNAL_DAILY_LIST(state, data) {
      state.journalDailyList = data;
    },
    APPEND_JOURNAL_DAILY_LIST(state, newData) {
      state.journalDailyList = [
        ...state.journalDailyList,
        ...newData,
      ]
    },
    ADD_JOURNAL_DAILY_LIST(state, data) {
      state.journalDailyList.unshift(data);
    },

    REMOVE_JOURNAL_DAILY_LIST(state, id) {
      state.journalDailyList = state.journalDailyList.filter(
        (item) => item.id !== id
      );
    },

    UPDATE_JOURNAL_DAILY_LIST(state, data) {
      const index = state.journalDailyList.findIndex(
        (item) => item.id === data.id
      );

      if (index !== -1) {
        state.journalDailyList.splice(index, 1, data);
      }
    },

    // BUAT OPTIONS
    SET_OPTIONS_LOADING(state, status) {
      state.optionsLoading = status;
    },
    SET_HAS_MORE_OPTIONS(state, status) {
      state.optionsPagination.hasMore = status;
    },
    SET_PAGE_OPTIONS(state, page) {
      state.optionsPagination.page = page
    },
    RESET_OPTIONS_PAGINATION(state) {
      state.optionsPagination.page = 1;
      state.optionsPagination.hasMore = true;
      state.options = [];
    },
    SET_OPTIONS(state, data) {
      state.options = data;
    },
    APPEND_OPTIONS(state, newData) {
      state.options = [
        ...state.options,
        ...newData,
      ]
    },
  },
  actions: {
    async getJournalList({ rootState, commit, state }, { isLoadMore = false, params = {} } = {}) {
      // Jangan request page berikutnya jika memang sudah habis
      if (
        isLoadMore &&
        !state.journalPagination.hasMore
      ) {
        return false;
      }

      const currentPage = isLoadMore
        ? state.journalPagination.page + 1
        : 1;

      try {
        // Atur halaman dan loading state
        if (!isLoadMore) {
          commit('SET_IS_LOADING', true)
          commit('RESET_JOURNAL_PAGINATION') // Kembali ke page 1
        } else {
          commit(
            "SET_JOURNAL_PAGE",
            currentPage
          ); // Naik ke page berikutnya
        }

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherjournal`,
            method: 'GET',
            params: {
              ...params,
              page: currentPage,
              rows: state.journalPagination.rows,
            }
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItems = res.data?.results || res.data || [];

        // Cek apakah data sudah habis (jika yang didapat kurang dari batas rows)
        const hasMore = newItems.length >= state.journalPagination.rows

        commit('SET_JOURNAL_HAS_MORE', hasMore)

        if (isLoadMore) {
          commit('APPEND_JOURNAL_LIST', newItems)
        } else {
          commit('SET_JOURNAL_LIST', newItems)
        }

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        // Jika load more gagal, kembalikan nomor halaman agar bisa dicoba lagi
        if (isLoadMore) {
          commit('SET_PAGE', state.page - 1)
        }
      } finally {
        if (!isLoadMore) {
          commit('SET_IS_LOADING', false)
        }
      }

      return false;
    },

    async getJournalDailyList({ rootState, commit, state }, { isLoadMore = false, params = {} } = {}) {
      // Jangan request page berikutnya jika memang sudah habis
      if (
        isLoadMore &&
        !state.journalDailyPagination.hasMore
      ) {
        return false;
      }

      const currentPage = isLoadMore
        ? state.journalDailyPagination.page + 1
        : 1

      try {
        // Atur halaman dan loading state
        if (!isLoadMore) {
          commit('SET_IS_LOADING', true)
          commit('RESET_JOURNAL_DAILY_PAGINATION') // Kembali ke page 1
        } else {
          commit('SET_JOURNAL_DAILY_PAGE', currentPage) // Naik ke page berikutnya
        }

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherjournaldaily`,
            method: 'GET',
            params: {
              ...params,
              page: currentPage,
              rows: state.journalDailyPagination.rows,
            }
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItems = res.data?.results || res.data || [];

        // Cek apakah data sudah habis (jika yang didapat kurang dari batas rows)
        const hasMore = newItems.length >= state.journalDailyPagination.rows

        commit('SET_JOURNAL_DAILY_HAS_MORE', hasMore)

        if (isLoadMore) {
          commit('APPEND_JOURNAL_DAILY_LIST', newItems)
        } else {
          commit('SET_JOURNAL_DAILY_LIST', newItems)
        }

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        // Jika load more gagal, kembalikan nomor halaman agar bisa dicoba lagi
        if (isLoadMore) {
          commit('SET_PAGE', state.page - 1)
        }
      } finally {
        if (!isLoadMore) {
          commit('SET_IS_LOADING', false)
        }
      }

      return false;
    },

    async getJournalCalendar(
      { rootState },
      { journal, semester, month } = {},
    ) {
      try {
        if (
          !journal?.id ||
          !journal?.subject?.code ||
          !journal?.classroom?.id ||
          !semester?.id ||
          !month
        ) {
          return [];
        }

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherjournaldaily`,
            method: "GET",
            params: {
              journal__subject: journal.subject.code,
              journal__classroom: journal.classroom.id,
              journal__semester: semester.id,
              journal_date_month: month,
              page: 1,
              rows: 100,
            },
          },
          authorized: true,
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return [];
        }

        return res.data?.results || [];
      } catch (error) {
        //console.log(
        //   "Gagal mengambil calendar journal:",
        //   error,
        // );

        return [];
      }
    },

    async getJournalCalendarMonth(
      { state, commit, dispatch },
      {
        journals = [],
        semester,
        month,
        force = false,
      } = {},
    ) {
      if (
        !semester?.id ||
        !month ||
        !journals.length
      ) {
        return false;
      }

      const cachedJournals = state.journalCalendar?.[month] || {};
      const hasAllJournalCaches = journals.every((journal) =>
        Object.prototype.hasOwnProperty.call(
          cachedJournals,
          journal.id,
        ),
      );

      // Bulan yang sama bisa memiliki beberapa journal. Cache hanya
      // dianggap lengkap jika data tersedia untuk semua journal diminta.
      if (
        !force &&
        hasAllJournalCaches
      ) {
        return true;
      }

      try {
        const results = await Promise.all(
          journals.map(async (journal) => {
            const dailyJournals = await dispatch(
              "getJournalCalendar",
              {
                journal,
                semester,
                month,
              },
            );

            return {
              journalId: journal.id,
              dailyJournals,
            };
          }),
        );

        const calendarMap = {};

        results.forEach(
          ({
            journalId,
            dailyJournals,
          }) => {
            calendarMap[journalId] =
              dailyJournals;
          },
        );

        /*
         * Jangan replace seluruh journalCalendar.
         *
         * Kita hanya menyimpan:
         *
         * journalCalendar[month]
         *
         * Contoh:
         *
         * journalCalendar[9] = {
         *   12: [...],
         *   15: [...],
         *   16: [...],
         * }
         */
        commit(
          "SET_JOURNAL_CALENDAR_MONTH",
          {
            month,
            data: calendarMap,
          },
        );

        return true;
      } catch (error) {
        console.error(
          "Gagal mengambil calendar journal bulan:",
          month,
          error,
        );

        return false;
      }
    },

    async getJournalDaily({ rootState, commit }, id) {

      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherjournaldaily/${id}`,
            method: 'GET',
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }
        commit('SET_JOURNAL_DAILY', res.data || [])
        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        return false;
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },

    async addJournalDaily({ rootState, commit }, data) {
      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherjournaldaily`,
            method: 'POST',
            data: data
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (![200, 201].includes(res.status)) {
          return { status: false, data: res.data }
        }
        return { status: true, data: res.data }

      } catch (error) {
        //console.log('Gagal edit data : ', error)
        return {
          status: false,
          data: error,
        };
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },
    async addJournal({ rootState, commit }, data) {
      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherjournal`,
            method: 'POST',
            data: data
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (![200, 201].includes(res.status)) {
          return { status: false, data: res.data }
        }
        return { status: true, data: res.data }

      } catch (error) {
        //console.log('Gagal edit data : ', error)
        return {
          status: false,
          data: error,
        };
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },
    async updateJournalDaily({ rootState, commit }, { id, data = {} } = {}) {

      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherjournaldaily/${id}`,
            method: 'PATCH',
            data: data
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return { status: false, data: res.data }
        }
        return { status: true, data: res.data }

      } catch (error) {
        //console.log('Gagal edit data : ', error)
        return {
          status: false,
          data: error,
        };
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },
    async deleteJournalDaily({ rootState, commit }, id) {

      try {
        commit('SET_IS_LOADING', true)

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/teacherjournaldaily/${id}`,
            method: 'DELETE',
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if ([200, 204].includes(res.status)) {
          return true;
        }

        return false
      } catch (error) {
        //console.log('Gagal hapus data : ', error)
        return false;
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },

    async getOptions({ rootState, commit, state }, { isLoadMore = false, params = {}, slug } = {}) {
      // Jangan request page berikutnya jika memang sudah habis
      if (isLoadMore && !state.optionsPagination.hasMore) {
        return false;
      }

      const currentPage = isLoadMore ? state.optionsPagination.page + 1 : 1

      try {
        // Atur halaman dan loading state
        if (!isLoadMore) {
          commit('SET_OPTIONS_LOADING', true)
          commit('RESET_OPTIONS_PAGINATION') // Kembali ke page 1
        } else {
          commit('SET_PAGE_OPTIONS', currentPage) // Naik ke page berikutnya
        }

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/${slug}`,
            method: 'GET',
            params: {
              ...params,
              page: currentPage,
              rows: state.optionsPagination.rows,
            }
          },
          authorized: true
        };

        // await new Promise((resolve) => setTimeout(resolve, 1000));
        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }

        const newItems = res.data?.results || res.data || [];

        // Cek apakah data sudah habis (jika yang didapat kurang dari batas rows)
        const hasMore = newItems.length >= state.optionsPagination.rows

        commit('SET_HAS_MORE_OPTIONS', hasMore)

        if (isLoadMore) {
          commit('APPEND_OPTIONS', newItems)
        } else {
          commit('SET_OPTIONS', newItems)
        }

        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        // Jika load more gagal, kembalikan nomor halaman agar bisa dicoba lagi
        if (isLoadMore) {
          commit('SET_PAGE_OPTIONS', state.optionsPagination.page - 1)
        }
      } finally {
        if (!isLoadMore) {
          commit('SET_OPTIONS_LOADING', false)
        }
      }

      return false;
    },
    async getSchedule({ rootState, state }, params) {

      try {

        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/subjectschedule`,
            method: 'GET',
            params: params
          },
          authorized: true
        };

        const res = await httpRequest(payload);

        if (res.status !== 200) {
          return false
        }
        state.subjectScheduleList = res.data.results || res.data || []
        return true

      } catch (error) {
        //console.log('Gagal mengambil data : ', error)
        return false;
      } finally {
        // commit('SET_IS_LOADING', false)
      }
    },
  }
})